import EventSourceBadge from './EventSourceBadge';

export default EventSourceBadge;
